import { Input } from '@/shared/components/ui/input';
import { Field, FieldGroup } from '@/shared/components/ui/field';
import type { StepProps } from '../types';
import { useTranslation } from 'react-i18next';

export function StepOrgName({ answers, setAnswer }: StepProps) {
  const { t } = useTranslation('onboarding');
  return (
    <div className="w-full">
      <FieldGroup>
        <Field>
          <Input
            type="text"
            data-testid="onboarding-org-name-input"
            placeholder={t('orgName.placeholder')}
            value={answers.orgName}
            onChange={(e) => setAnswer('orgName', e.target.value)}
            autoComplete="off"
            autoFocus
            className="w-full"
          />
        </Field>
      </FieldGroup>
    </div>
  );
}
